<template>
  <aside class="be-room-card__sidebar">
    <div class="be-room-card__gallery">
      <div class="be-room-card__gallery-main" @click="$emit('open-detail')">
        <img :src="mainImage" :alt="type.name" />
        <button
          type="button"
          class="be-room-card__share be-press"
          v-b-tooltip.hover.right
          :title="shareTooltip"
          @click.stop="copyShareUrl">
          <img src="../../../../../assets/img/icon/share-outline-white.svg" width="30" alt="Share" />
        </button>
      </div>
      <div class="be-room-card__gallery-thumbs" v-if="galleryThumbs.length > 0">
        <div
          class="be-room-card__gallery-thumb"
          v-for="(img, i) in galleryThumbs"
          :key="i"
          @click="$emit('open-detail')">
          <img :src="img.image_url" :alt="type.name" />
          <div
            v-if="i === galleryThumbs.length - 1 && hasMoreImages"
            class="be-room-card__viewall">
            {{ $t('general.view-all') }}
          </div>
        </div>
      </div>
    </div>

    <p class="be-room-card__name" @click="$emit('open-detail')">{{ type.name }}</p>

    <div class="be-room-card__specs">
      <div class="be-room-card__spec" v-if="type.room_size != '0'">
        <svg class="be-room-card__spec-icon" height="18" width="18" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M2.72896 16.9297H13.271C15.0962 16.9297 16 16.0258 16 14.2355V3.62388C16 1.83355 15.0962 0.929688 13.271 0.929688H2.72896C0.912549 0.929688 0 1.82486 0 3.62388V14.2355C0 16.0345 0.912549 16.9297 2.72896 16.9297Z" fill="#777" />
          <path d="M2.84192 9.68133L2.87669 6.54392C2.87669 6.38748 2.94621 6.21366 3.0505 6.10937C3.28516 5.86603 3.6241 5.86603 3.86745 6.10937C3.98043 6.22235 4.04996 6.3701 4.04127 6.52653L4.02389 7.85625L3.99781 8.33424L4.27592 8.03007L8.37806 3.92795C8.62139 3.69329 8.97774 3.69329 9.20372 3.92795C9.44705 4.17129 9.43837 4.51893 9.20372 4.75358L5.11025 8.85568L4.78869 9.14254L5.29276 9.12511L6.61379 9.10776C6.77023 9.10776 6.90928 9.15989 7.03095 9.28159C7.26561 9.51625 7.26561 9.84649 7.02226 10.0811C6.92666 10.1854 6.77023 10.255 6.6051 10.2637L3.45028 10.2984C3.12872 10.3071 2.84192 10.0203 2.84192 9.68133ZM13.1754 8.16043L13.1407 11.3152C13.132 11.4804 13.0798 11.6455 12.9756 11.7411C12.7409 11.9758 12.3932 11.9758 12.1586 11.7411C12.0456 11.6194 11.9935 11.4804 11.9935 11.324L12.0108 9.99422L12.0456 9.49882L11.7502 9.82039L7.63933 13.9138C7.40466 14.1572 7.05702 14.1485 6.82237 13.9138C6.57902 13.6705 6.57902 13.3315 6.82237 13.0969L10.9245 8.98606L11.2461 8.70795L10.742 8.72537L9.40359 8.75141C9.25585 8.75141 9.1168 8.69059 8.9951 8.57757C8.76045 8.34292 8.76045 8.01269 9.00378 7.76065C9.10805 7.66505 9.28189 7.58683 9.42094 7.58683L12.5757 7.56075C12.906 7.56075 13.1754 7.8128 13.1754 8.16043Z" fill="white" />
        </svg>
        <span>{{ type.room_size }}m²</span>
      </div>

      <div class="be-room-card__spec" v-if="$isNotEmptyV3(type.max_guests)">
        <svg class="be-room-card__spec-icon" width="18" viewBox="0 0 23 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M5.67617 7.96519C7.11451 7.96519 8.36733 6.66604 8.36733 4.98791C8.36733 3.31754 7.10679 2.0957 5.67617 2.0957C4.2378 2.0957 2.97728 3.34848 2.97728 5.00338C2.97728 6.66604 4.23006 7.96519 5.67617 7.96519ZM1.36104 14.9483H9.97584C10.958 14.9483 11.3369 14.5616 11.3369 13.8579C11.3369 11.7235 9.15611 9.14839 5.66844 9.14839C2.18076 9.14839 0 11.7235 0 13.8579C0 14.5616 0.38666 14.9483 1.36104 14.9483Z" fill="#777" />
          <path d="M9.71293 16H19.4335C21.4673 16 22.1324 15.0179 22.1324 13.9198C22.1324 11.3214 19.1551 8.11987 14.5693 8.11987C9.99128 8.11987 7.01401 11.3214 7.01401 13.9198C7.01401 15.0179 7.67905 16 9.71293 16Z" fill="#777" />
          <path d="M14.5771 7.78735C16.2397 7.78735 17.6703 6.30256 17.6703 4.36926C17.6703 2.45916 16.232 1.04398 14.5771 1.04398C12.9222 1.04398 11.4838 2.49009 11.4838 4.38473C11.4838 6.30256 12.9144 7.78735 14.5771 7.78735Z" fill="#777" />
        </svg>
        <span>{{ type.max_guests }} {{ $pluralWord(type.max_guests, 'Guest') }}</span>
      </div>

      <div class="be-room-card__spec" v-if="$isNotEmptyV2(type.bed)">
        <svg class="be-room-card__spec-icon" width="18" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0 10.703C0 11.0313 0.208366 11.2397 0.536701 11.2397H0.91555C1.23757 11.2397 1.45225 11.0313 1.45225 10.703V9.76854C1.52171 9.78745 1.73007 9.80011 1.88161 9.80011H14.1184C14.2699 9.80011 14.4783 9.78745 14.5478 9.76854V10.703C14.5478 11.0313 14.7624 11.2397 15.0845 11.2397H15.4633C15.7916 11.2397 16 11.0313 16 10.703V6.9398C16 5.73379 15.3307 5.0708 14.1247 5.0708H1.8753C0.669299 5.0708 0 5.73379 0 6.9398V10.703Z" fill="#777" />
          <path d="M1.51538 4.16849H3.11917V3.25926C3.11917 2.67204 3.44751 2.35002 4.04735 2.35002H6.40251C6.99606 2.35002 7.32441 2.67204 7.32441 3.25926V4.16849H8.75769V3.25926C8.75769 2.67204 9.08603 2.35002 9.71746 2.35002H11.9274C12.5588 2.35002 12.8871 2.67204 12.8871 3.25926V4.16849H14.4972V2.35634C14.4972 1.18822 13.8658 0.588379 12.7293 0.588379H3.27702C2.14048 0.588379 1.51538 1.18822 1.51538 2.35634V4.16849Z" fill="#868686" />
        </svg>
        <span>
          <template v-for="(bed, index) in type.bed">{{ bed.qty }} {{ bed.name }}<span v-if="index + 1 < type.bed.length">, </span></template>
        </span>
      </div>

      <div class="be-room-card__spec" v-for="facility in facilityHighlight" :key="facility.name">
        <img class="be-room-card__spec-icon" :src="facility.icon" width="18" />
        <span>{{ facility.name }}</span>
      </div>
    </div>

    <button type="button" class="be-room-card__gallery-btn be-press" @click="$emit('open-detail')">
      {{ $t('hotel.unit-type.' + type.type + '.detail') }}
    </button>
  </aside>
</template>

<script>
  import { mapGetters } from 'vuex';

  const NO_IMAGE_URL = 'https://guestapps.s3-ap-southeast-1.amazonaws.com/noimage.png';
  const GALLERY_THUMB_COUNT = 3;
  const FACILITY_FALLBACK_COUNT = 5;

  export default {
    name: 'RoomCardSidebar',
    props: {
      type: {
        type: Object,
        default: () => ({})
      }
    },
    computed: {
      ...mapGetters(['getMerchant', 'getBeSortBy']),
      unitLabel(){
        return this.$t('hotel.unit-type.' + this.type.type + '.unit');
      },
      shareTooltip(){
        return `Share ${this.unitLabel} via url`;
      },
      // any grouping other than room type lists rates, so the card id is a rate id;
      // BeDirectDetail resolves the link into the "Show only" filter
      shareUrl(){
        const referenceType = this.getBeSortBy === 'room_type' ? 'room_type' : 'rate';
        return `${window.location.origin}/${this.getMerchant.code}/hotel-direct-detail/${referenceType}/${this.getBeSortBy}/${this.type.id}`;
      },
      roomImages(){
        return Array.isArray(this.type.image) ? this.type.image : [];
      },
      mainImage(){
        return this.roomImages.length > 0 ? this.roomImages[0].image_url : NO_IMAGE_URL;
      },
      galleryThumbs(){
        return this.roomImages.slice(1, 1 + GALLERY_THUMB_COUNT);
      },
      hasMoreImages(){
        return this.roomImages.length > 1 + GALLERY_THUMB_COUNT;
      },
      facilityHighlight(){
        if(this.$isEmpty(this.type) && this.$isEmpty(this.type.facility)) return [];

        const hightlight = this.type.facility.filter(f => this.$isNotEmptyV2(f.is_highlight) && f.is_highlight);

        if(this.$isEmpty(hightlight)) return this.type.facility.slice(0, FACILITY_FALLBACK_COUNT);

        return hightlight;
      }
    },
    methods: {
      copyShareUrl(){
        this.$copyText(this.shareUrl, `${this.unitLabel} URL copied!`);
      }
    }
  }
</script>

<style scoped>
.be-room-card__sidebar {
  background: #fff;
  border: 1px solid var(--be-v3-border, #d5d9e0);
  border-radius: var(--be-v3-radius, 12px);
  padding: 12px;
  align-self: start;
}
.be-room-card__gallery {
  margin: -12px -12px 0;
}
.be-room-card__gallery-main {
  position: relative;
  width: 100%;
  height: 200px;
  border-radius: var(--be-v3-radius, 12px) var(--be-v3-radius, 12px) 0 0;
  overflow: hidden;
  cursor: pointer;
}
.be-room-card__gallery-main img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.be-room-card__share {
  position: absolute;
  right: 10px;
  bottom: 10px;
  display: flex;
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
}
.be-room-card__gallery-thumbs {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(0, 1fr));
  gap: 4px;
  margin-top: 4px;
}
.be-room-card__gallery-thumb {
  position: relative;
  height: 64px;
  overflow: hidden;
  cursor: pointer;
}
.be-room-card__gallery-thumb img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.be-room-card__viewall {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.35);
  backdrop-filter: blur(4px);
  color: #fff;
  font-size: var(--be-v3-text-caption, 0.75rem);
  font-weight: 600;
  text-decoration: underline;
}
.be-room-card__name {
  font-family: var(--be-v3-content-font, BeV3Sans), sans-serif;
  font-weight: 800;
  /* merchant custom fonts register one file across weight 100–900, so font-weight
     steps render identically — stroke thickens the glyph regardless of the face */
  -webkit-text-stroke: 0.35px currentColor;
  font-size: var(--be-v3-text-heading, 1.125rem);
  line-height: 1.3;
  text-wrap: balance;
  color: #1a1a2e;
  margin: 14px 0 12px;
  cursor: pointer;
}
/* two per row on mobile, where the card is full width; the desktop sidebar is only
   ~190-260px wide so it falls back to one per row */
.be-room-card__specs {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px 12px;
  margin-bottom: 14px;
}
.be-room-card__spec {
  display: flex;
  align-items: flex-start;
  min-width: 0;
  font-size: var(--be-v3-text-body, 0.875rem);
  line-height: 1.4;
  color: #333;
}
.be-room-card__spec-icon {
  margin-right: 10px;
  margin-top: 1px;
  flex-shrink: 0;
}
.be-room-card__gallery-btn {
  width: 100%;
  border: 1px solid var(--be-v3-border, #d5d9e0);
  background: #f7f8fa;
  color: var(--merchant-primary-color, #79a33a);
  border-radius: var(--be-v3-button-radius, 8px);
  padding: 10px;
  font-weight: 600;
  font-size: var(--be-v3-text-body, 0.875rem);
  cursor: pointer;
}
@media screen and (min-width: 992px) {
  .be-room-card__sidebar {
    position: sticky;
    top: 100px;
  }
  .be-room-card__gallery-main {
    height: 170px;
  }
  .be-room-card__specs {
    grid-template-columns: 1fr;
  }
}
/* Jost (the v3 default content font) is a real variable font that already gets
   heavier at font-weight 800 — the stroke above was tuned for BeV3Sans/merchant
   single-file fonts and doubles up on Jost, so drop it when no custom font is set. */
.be-v3-content-font-default .be-room-card__name {
  -webkit-text-stroke: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/hotel/be/v3/room-card/RoomCardSidebar.vue